import React from 'react';

/** Accessible on/off switch. Controlled: pass `checked` and `onChange(nextChecked)`. */
const Toggle = ({ checked, onChange, disabled = false, label, title, className = '' }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    title={title || label}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0062FB]/40 disabled:cursor-not-allowed disabled:opacity-50 ${
      checked ? 'bg-[#0062FB]' : 'bg-zinc-300'
    } ${className}`}
  >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
        checked ? 'translate-x-[18px]' : 'translate-x-0.5'
      }`}
    />
  </button>
);

export default Toggle;
